var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('page-header',{attrs:{"menuItems":_vm.menuItems},on:{"menuClick":_vm.changeReport}},[_vm._v(" "+_vm._s(_vm.reportName)+" Report ")]),_c(_vm.selectedComponent,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }